import { Column, FieldType } from "../../../../../features/ui"
import { CsvImportResult, ImportedCsvReport } from '../../../../../features/importer'

interface Props {
    csvImportResult: CsvImportResult
    onNewUpdate: () => void
    listName?: string
}

export const ImportedCustomerTypeReport = (props: Props) => {
    const { csvImportResult, onNewUpdate, listName } = props

    const hasVat = csvImportResult.importedRows.length > 0 && 
                  csvImportResult.importedRows[0].priceVat !== null;
    
    const columns: Column[] = [
        {
            name: 'rowIndex',
            type: FieldType.NUMBER,
            label: 'Fila'
        },
        {
            name: 'name',
            type: FieldType.TEXT,
            label: listName ? `${listName}` : 'Nombre Lista'
        },
        {
            name: 'yield',
            type: FieldType.PERCENTAGE,
            label: 'Ajuste'
        },
        {
            name: 'supplierCode',
            type: FieldType.TEXT,
            label: 'Código Interno'
        },
        {
            name: hasVat ? 'priceVat' : 'price',
            type: FieldType.PRICE,
            label: hasVat ? 'Nuevo Precio c/IVA' : 'Nuevo Precio'
        }
    ];

    return <ImportedCsvReport
        columns={columns}
        csvImportResult={csvImportResult}
        onNewUpdate={onNewUpdate}
    />
}
